import { motion } from "framer-motion";
import { UserCirclePlus, IdentificationCard, FileArrowUp, HandCoins } from "@phosphor-icons/react";

const steps = [
  { icon: UserCirclePlus, title: "Register Interest", desc: "Join the Invoquity early access list in under 2 minutes — no obligation." },
  { icon: IdentificationCard, title: "Complete Verification", desc: "Digital KYC and business verification, tailored to Indian MSMEs and exporters." },
  { icon: FileArrowUp, title: "Upload Eligible Invoices", desc: "Submit outstanding invoices from your buyers, ready for our review." },
  { icon: HandCoins, title: "Receive Working Capital", desc: "Funds land in your account — put them to work immediately." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-24 md:py-32 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">How It Works</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Four steps between you and working capital.
          </h2>
        </div>

        <div className="mt-16 grid lg:grid-cols-4 gap-6 relative">
          <div aria-hidden className="hidden lg:block absolute top-8 left-8 right-8 h-px bg-gradient-to-r from-transparent via-emerald-300 to-transparent" />
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              data-testid={`how-step-${i}`}
              className="relative rounded-2xl bg-white border border-slate-100 p-7 shadow-soft"
            >
              <div className="flex items-center justify-between">
                <div className="grid place-items-center w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-700 to-emerald-800 text-white shadow-glow-blue">
                  <s.icon size={22} weight="duotone" />
                </div>
                <span className="font-display text-4xl font-semibold text-slate-100 select-none">0{i + 1}</span>
              </div>
              <h3 className="mt-6 font-display text-lg md:text-xl font-medium text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 text-sm text-slate-500 max-w-2xl">
          Invoquity is in early access. These steps reflect the flow founding customers will experience at launch.
        </p>
      </div>
    </section>
  );
}
